// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as FlipComponent} from './Flip.svg';

import Icon, { TIconProps } from '../Icon';

export const IconFlip = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <FlipComponent/>
  </Icon>
));
